// /app/frontend/src/components/frugal-v2/components/UnsavedChangesModal.jsx
// Modal for unsaved budget changes (30 lines)

import React from 'react';

const UnsavedChangesModal = ({ isOpen, onStay, onDiscard, t }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
      <div className="bg-slate-800 rounded-xl p-6 mx-4 max-w-sm w-full border border-amber-500/30">
        <h3 className="text-lg font-semibold text-white mb-2">
          {t('frugal.budget.unsavedTitle', 'Cambios sin guardar')}
        </h3>
        <p className="text-slate-400 text-sm mb-4">
          {t('frugal.budget.unsavedMessage', 'Tienes cambios en tu presupuesto que no has guardado. ¿Qué deseas hacer?')}
        </p>
        <div className="flex gap-3">
          <button
            onClick={onStay}
            className="flex-1 py-2 bg-emerald-600 hover:bg-emerald-500 text-white rounded-lg font-medium"
          >
            {t('frugal.budget.stayAndSave', 'Guardar')}
          </button>
          <button
            onClick={onDiscard}
            className="flex-1 py-2 bg-slate-700 hover:bg-slate-600 text-slate-300 rounded-lg"
          >
            {t('frugal.budget.discard', 'Descartar')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UnsavedChangesModal;
